import { useState } from "react";
import Footer from "../Components/Footer/Footer";
import Nav from "../Components/Nav/Nav";
import Support from "../Components/Support/Support";
import logo from "../Assets/Logo/lipana.svg";

const Contact = () => {
  const [sticky, setSticky] = useState("#");

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 100) {
        return setSticky("sticky");
      } else {
        return setSticky("#");
      }
    });
  }
  return (
    <section>
      <div
        className={`z-50 w-full text-blackColor bg-[#f8f7f4] ${
          sticky === "sticky" ? `fixed top-0 w-full` : ``
        }`}
      >
        <Nav logo={logo} />
      </div>
      <Support />
      <Footer />
    </section>
  );
};

export default Contact;
